export default __webpack_public_path__ + "static/media/steam_card.757ba815.svg";